import { Component } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { LS_DEVICE_CODE_NAME } from '../../services/signature.service';
import { environment } from '../../../../environments/environment';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'app-set-terminal-code-dialog',
    templateUrl: './set-terminal-code.component.html',
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatFormField, MatInput, ReactiveFormsModule, MatDialogActions, MatButton, MatDialogClose]
})
export class SetTerminalCodeComponent {
  formControl = new FormControl<string>('', Validators.required);
  appUrl = environment.app_url;

  constructor(public dialogRef: MatDialogRef<SetTerminalCodeComponent>) {
    const code = localStorage.getItem(LS_DEVICE_CODE_NAME);
    if (code) {
      this.formControl.patchValue(code);
    }
  }
}
